var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "form-group" }, [
      _c("label", { attrs: { for: "emailLogin" } }, [
        _vm._v(_vm._s(_vm.title)),
      ]),
      _c("span", { staticClass: "invalid-feedback" }, [
        _vm._v(" " + _vm._s(_vm.errorMsg) + " "),
      ]),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.username,
            expression: "username",
          },
        ],
        ref: "username",
        staticClass: "form-control",
        class: { "has-error": _vm.errorMsg },
        attrs: { type: "text", readonly: "", name: "loginusername" },
        domProps: { value: _vm.username },
        on: {
          focus: function ($event) {
            return _vm.removeReadonly($event)
          },
          input: [
            function ($event) {
              if ($event.target.composing) return
              _vm.username = $event.target.value
            },
            function ($event) {
              return _vm.updateUsername()
            },
          ],
          blur: function ($event) {
            return _vm.getUsersForEmail()
          },
        },
      }),
    ]),
    _vm.usernames.length
      ? _c("div", { staticClass: "overlay-back" }, [
          _c(
            "div",
            {
              staticClass: "usernames",
              class: { mobile: _vm.isMobile(), desktop: _vm.isDesktop() },
            },
            [
              _c("div", { staticClass: "text-center" }, [
                _c("p", [
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$tc(
                          "you_have_multiple_usernames",
                          _vm.usernames.length
                        )
                      ),
                    },
                  }),
                  _c("br"),
                  _c("b", [_vm._v(_vm._s(_vm.$t("choose_login_account")))]),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "list" },
                _vm._l(_vm.usernames, function (user) {
                  return _c(
                    "div",
                    {
                      staticClass: "card",
                      on: {
                        click: function ($event) {
                          return _vm.chooseUsername(user)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "card-body" }, [
                        _vm._v(" " + _vm._s(user) + " "),
                      ]),
                    ]
                  )
                }),
                0
              ),
            ]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }